export default __webpack_public_path__ + "static/media/ladiko-suites-by-night.888f4aca.jpg";